import React from "react";
import { MessageSquare, RotateCcw } from "lucide-react";
import { formatTimestamp } from "./documentUtils";

// Wave 3 — workflow visualization for the action trail: a vertical timeline of
// every reviewHistory + history entry (newest first), with comments, return
// targets and per-entry attachments. Attachment opens stay authenticated —
// handled by the parent's authorized download handler.
const FileHistoryTimeline = ({ entries, onOpenAttachment }) => {
  if (!Array.isArray(entries) || entries.length === 0) return null;

  return (
    <div className="mt-4">
      <h3 className="mb-2 text-lg font-semibold">File Action History</h3>

      <ol className="file-card__timeline">
        {entries.map((entry, index) => (
          <li key={index} className="file-card__timeline-item">
            <span className="file-card__timeline-marker" aria-hidden="true" />
            <div className="file-card__timeline-body">
              <p className="text-sm text-gray-700" style={{ marginBottom: 4 }}>
                <strong>{entry.action || "Action"}</strong>{" "}
                by <span className="font-medium text-blue-700">{entry.by || "Unknown"}</span>{" "}
                on <span className="italic text-gray-600">{formatTimestamp(entry.at)}</span>
              </p>

              {entry.returnToRole && (
                <p className="text-xs italic text-yellow-700" style={{ marginBottom: 4 }}>
                  <RotateCcw size={13} aria-hidden="true" /> Returned to role:{" "}
                  <strong>{entry.returnToRole}</strong>
                </p>
              )}

              {Array.isArray(entry.comments) && entry.comments.length > 0 && (
                <div style={{ marginLeft: 10 }}>
                  {entry.comments.map((c, i) => (
                    <p key={i} className="text-xs text-gray-600" style={{ margin: 0 }}>
                      <MessageSquare size={13} aria-hidden="true" /> {c}
                    </p>
                  ))}
                </div>
              )}

              {Array.isArray(entry.attachments) && entry.attachments.length > 0 && (
                <div style={{ marginLeft: 10, marginTop: 6 }}>
                  <p className="text-xs font-semibold text-gray-700" style={{ marginBottom: 4 }}>
                    Attachments:
                  </p>
                  {entry.attachments.map((att, i) => (
                    <button
                      key={i}
                      type="button"
                      onClick={() => onOpenAttachment(att)}
                      className="text-xs text-blue-600 underline block"
                      style={{ marginBottom: 2 }}
                    >
                      {att.originalName || att.fileName}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default FileHistoryTimeline;
